'use strict';
const angular = require('angular');

export default angular.module('conduuApp.weather', [])
  .directive('weather', function($timeout) {
    return {
      template: '<div id="weather"></div></div>',
      restrict: 'EA',
      scope: {
        location: "@",
        unit: "@"
      },
      link: function (scope, element, attrs) {

        var unit = scope.unit || "f";

        $timeout(function () {

          $(document).ready(function () {

            let currentWeather = "",
            forecast = "";

            $.simplerWeather( {
              location: scope.location,
              units: 'f',
              authmethod: 'proxy',
              proxyurl: '/api/integrations/weather',
              success: function( weather ) {
                currentWeather = '<h2> <i class="icon ' + weather.icon + '"></i> ' +
                  Math.round( weather.temp ) + '&deg;' + weather.unit.toUpperCase() + "</h2>";

                currentWeather += '<p>' + weather.currently + '</p>';

                $( "#weather" ).html( currentWeather );

              },
              error: function( error ) {
                $( "#weather" ).html( '<p>' + error + '</p>' );
              }
            } ); //end main weather display


          });

        });

      }
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/weather/weather.directive.js